import { Autocomplete, TextField } from '@mui/material';

interface LocationEndFieldProps {
  disabled: boolean;
  options: string[];
  value: string | null;
  label: string;
  onChange: (value: string | null) => void;
}

/** One end (A or Z) of a point-to-point request, picked from the existing locations. */
export function LocationEndField({ disabled, options, value, label, onChange }: LocationEndFieldProps) {
  return (
    <div style={{ breakInside: 'avoid', marginBottom: '1.5rem' }}>
      <Autocomplete
        disabled={disabled}
        sx={{ width: '100%' }}
        size="small"
        options={options}
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
          />
        )}
      />
    </div>
  );
}
